import React from 'react'
import { Grid } from 'semantic-ui-react'
import { SemanticDropdownAutoFocus } from '../../shared/Helpers'
import { GridContainer } from '../../shared/StyledComponents'
import FormField, { FormLayout } from '../../shared/newFormElements'
import { fieldTypes } from '../constants'
import { getInitialValues, getMinMaxRange } from '../helpers'
import containerForm from './containerForm'

const TEXT_AREA_MAX_LENGTH_4000 = 4000
const TEXT_MAX_LENGTH_300 = 300

class UndecoratedForm extends React.Component<any> {
  static defaultProps = {
    dynamicOptions: {},
  }

  leftHeightTot = 0
  heightTot = 0
  rightHeightTot = 0

  componentDidMount() {
    if (this.props.selfInitializeForm) {
      if (this.props.hidden) {
        this.props.fields.forEach((df) => this.props.regField(df.FieldName))
      }

      this.props.initialize(getInitialValues(this.props.fields))
    }
  }

  getAdditionalProps(field, height) {
    const {
      dynamicOptions: { childSelectOptions = {}, masterSelects = {} },
      form,
      prefix,
    } = this.props

    const actualFieldName = prefix ? `${prefix}.${field.FieldName}` : field.FieldName

    switch (fieldTypes[field.FieldDataType]) {
      case 'select':
        return {
          options: field.LookupData,
          flags: masterSelects[actualFieldName]
            ? {
                modifies: {
                  modifier: actualFieldName,
                  field: masterSelects[actualFieldName],
                  form,
                },
              }
            : undefined,
          upward: height > 350,
        }

      case 'child-select':
        return {
          type: 'select',
          options: childSelectOptions[actualFieldName] || [],
          upward: height > 350,
        }

      case 'multi-checkbox': {
        return {
          label: field.FieldDefData.match(/<(.*?)>/g).map(
            // get rid off "<>" symbols
            (item) => item.substr(1, item.length - 2),
          ),
        }
      }

      case 'textarea': {
        return {
          autoHeight: false,
        }
      }
      case 'number':
      case 'float': {
        if (field.RequiredField === 1) {
          return getMinMaxRange(field)
        }
        break
      }
      case 'date': {
        if (height > 300) {
          return { upward: true }
        }
        break
      }
      default:
        return null
    }
  }

  renderFields(fields) {
    const { editing, prefix } = this.props

    return fields.map((field, index) => (
      // @ts-ignore
      <FormLayout key={field.ID} label={field.DisplayTitle} labelFieldProportions="6:8">
        {
          (field.FieldDataType === 4 ? (this.heightTot = this.heightTot + 60) : (this.heightTot = this.heightTot + 45),
          fieldTypes[field.FieldDataType] === 'select' ? (
            <SemanticDropdownAutoFocus autoFocus={index === 0 && field.SubGroupID === 1}>
              <FormField
                disabled={!editing || field.PermLevel === 2}
                type={fieldTypes[field.FieldDataType]}
                name={prefix ? `${prefix}.${field.FieldName}` : field.FieldName}
                required={field.RequiredField === 1}
                style={{ height: 35 }}
                search
                {...this.getAdditionalProps(field, this.heightTot)}
              />
            </SemanticDropdownAutoFocus>
          ) : (
            <FormField
              disabled={!editing || field.PermLevel === 2}
              autoFocus={index === 0 && field.SubGroupID === 1}
              type={fieldTypes[field.FieldDataType]}
              name={prefix ? `${prefix}.${field.FieldName}` : field.FieldName}
              required={field.RequiredField === 1 && editing}
              search
              {...this.getAdditionalProps(field, this.heightTot)}
              style={{ height: field.FieldDataType === 4 ? 50 : 35 }}
              maxLength={field.FieldDataType === 4 ? TEXT_AREA_MAX_LENGTH_4000 : TEXT_MAX_LENGTH_300}
            />
          ))
        }
      </FormLayout>
    ))
  }

  renderRightSide() {
    const fields = this.props.fields.filter(
      (field) =>
        field.SubGroupID === 2 &&
        (field.FieldDataType !== 8 || this.props.fields.some((ff) => ff.ID === field.ParentFieldID)),
    )

    this.heightTot = 0
    return this.renderFields(fields)
  }

  renderLeftSide() {
    const fields = this.props.fields.filter(
      (field) =>
        field.SubGroupID === 1 &&
        (field.FieldDataType !== 8 || this.props.fields.some((ff) => ff.ID === field.ParentFieldID)),
    )

    this.heightTot = 0
    return this.renderFields(fields)
  }

  render() {
    if (this.props.hidden) return null

    return (
      <GridContainer>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>{this.renderLeftSide()}</Grid.Column>

            <Grid.Column>{this.renderRightSide()}</Grid.Column>
          </Grid.Row>
        </Grid>
      </GridContainer>
    )
  }
}

export { UndecoratedForm }

// @ts-ignore
export default containerForm(UndecoratedForm)
